import MarkdownCopy from '@components/cms/Slices/MarkdownCopy';
import Button from '@components/ui/Button';
import Heading from '@components/ui/Heading';
import cn from 'classnames';
import { useLocale } from '@hooks/useLocale';
import styles from './CopyCard.module.scss';

interface CopyCardProps {
  copyPosition?: string;
  title?: string;
  ctaTitle?: string;
  ctaLink?: string;
  copy?: string;
  handleCTAClick?: () => void;
}

const CopyCard = ({
  copyPosition,
  title,
  ctaTitle,
  ctaLink,
  copy,
  handleCTAClick,
}: CopyCardProps) => {
  const locale = useLocale();
  return (
    <div
      className={cn(styles.textContainer, {
        [styles.alignLeft]: copyPosition === 'left' || copyPosition === 'right',
      })}
    >
      {title && (
        <Heading semanticLevel="h3" styleLevel="3">
          {title}
        </Heading>
      )}
      {copy && <MarkdownCopy text={copy ?? ''} className={styles.copy} />}
      {ctaTitle && ctaLink && (
        <Button
          label={ctaTitle}
          size="large"
          type="button"
          href={`/${locale}${ctaLink}`}
          handleClick={handleCTAClick}
        />
      )}
    </div>
  );
};

export default CopyCard;
